/**
 * SSR-safe wrapper around `localStorage`.
 *
 * The app is prerendered at build time, where `localStorage` does not exist.
 * Reads return `null` and writes are dropped on the server instead of throwing
 * and aborting the render.
 */
export class BrowserStorage {
  static getItem(key: string): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    try {
      return localStorage.getItem(key);
    } catch {
      // Private mode or blocked site data.
      return null;
    }
  }

  static setItem(key: string, value: string): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    try {
      localStorage.setItem(key, value);
    } catch {
      // Quota exceeded or blocked site data: nothing sensible to do.
    }
  }
}
